import { GridApiRef, GridCsvExportOptions } from '@mui/x-data-grid-pro';
import { parse } from 'papaparse';

export const exportInventory = (apiRef: GridApiRef, options?: GridCsvExportOptions) => {
	const csvStringData = getCsvDataWithHeaderRow(apiRef, options);
	exportDataAsCsv(csvStringData, options);
};

const getCsvDataWithHeaderRow = (apiRef: GridApiRef, options?: GridCsvExportOptions) => {
	const inventoryDataCsvString = apiRef.current.getDataAsCsv(options);
	const columns = apiRef.current.getAllColumns();
	const headerNameFieldIdMap = columns.reduce((tot, col) => {
		if (col.headerName === undefined || col.field === undefined) return tot;
		return {
			...tot,
			[col.headerName]: col.field,
		};
	}, {} as { [headerName: string]: string });
	const parsedFirstRowCsvData = parse<string>(inventoryDataCsvString, {
		preview: 1,
		header: true,
		quoteChar: '',
		escapeChar: '',
		delimiter: options?.delimiter ?? '',
		transformHeader: (value) => {
			// MUI Data grid and papaparse do not handle double quotes at the start of the string the same way, so we need to manually transform quote marks from two quote marks to single quote mark
			const val = value.replace(/""/g, '"');
			return val;
		},
	});
	const headerColumns = parsedFirstRowCsvData.meta.fields;
	if (!headerColumns) {
		throw new Error('Error exporting .csv');
	}
	const delimiter = parsedFirstRowCsvData.meta.delimiter;
	const newline = parsedFirstRowCsvData.meta.linebreak;
	const fieldColumns = headerColumns.map((headerColumn) => headerNameFieldIdMap[headerColumn]);
	if (fieldColumns.some((col) => col === undefined)) {
		throw new Error('Error exporting .csv');
	}
	const firstRowString = fieldColumns.join(delimiter);
	const newCsvString = firstRowString + newline + inventoryDataCsvString;
	return newCsvString;
};

// Custom csv download implementation, following the same behaviour that MUI library uses
// https://github.com/mui-org/material-ui-x/blob/e45cf31723303ccc20cf21cccb6ef1e975364bed/packages/grid/_modules_/grid/hooks/features/export/useGridCsvExport.tsx
// https://github.com/mui-org/material-ui-x/blob/e45cf31723303ccc20cf21cccb6ef1e975364bed/packages/grid/_modules_/grid/utils/exportAs.ts
const exportDataAsCsv = (csv: string, options?: GridCsvExportOptions): void => {
	const blob = new Blob([options?.utf8WithBom ? new Uint8Array([0xef, 0xbb, 0xbf]) : '', csv], {
		type: 'text/csv',
	});
	const fileName = options?.fileName ?? document.title;
	const fullName = `${fileName}.csv`;
	if ('download' in HTMLAnchorElement.prototype) {
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fullName;
		a.click();
		setTimeout(() => {
			URL.revokeObjectURL(url);
		});
		return;
	}
	throw new Error('Error exporting .csv');
};
